module.exports = __webpack_public_path__ + "img/bicom-bodycheck.4b7e1b28.jpg";